import { InjectionToken } from '@angular/core';
import { FuseNavigation } from 'app/projects/fuse/src/lib/types/fuse-navigation';

export const MAXBRAIN_NAVIGATION = new InjectionToken<FuseNavigation[]>('MAXBRAIN_NAVIGATION');
